<template>
  <div class="form-row align-items-center">
    <div class="col-12 col-md-3" v-if="available_filters">
      <div :class="typeFilterClass()">
        <div class="news-filter__inner">
          <dl>
            <dt @click="type_filter_open = !type_filter_open">
              <span class="label">{{ getTypeFilterLabel() }}</span>
              <span class="arrow"></span>
            </dt>
            <div class="dd-container">
              <dd
                v-for="(title, slug) in available_filters"
                :key="slug"
                @click="
                  applyTypeFilter(slug);
                  type_filter_open = false;
                  type_filter_label = title;
                "
                :class="current_content_type === slug ? 'active' : ''"
                v-html="title"
              ></dd>
            </div>
          </dl>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-3" v-if="available_categories">
      <div :class="categoryFilterClass()">
        <div class="news-filter__inner">
          <dl>
            <dt @click="category_filter_open = !category_filter_open">
              <span class="label">{{ getCategoryFilterLabel() }}</span>
              <span class="arrow"></span>
            </dt>
            <div class="dd-container">
              <dd
                v-for="category in available_categories"
                :key="category.slug"
                @click="
                  applyCategoryFilter(category);
                  category_filter_open = false;
                  category_filter_label = category.name;
                "
                :class="current_category === category.slug ? 'active' : ''"
                v-html="category.name"
              ></dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResourcesFilter",
  data() {
    return {
      type_filter_open: false,
      type_filter_label: "Select content type",
      category_filter_open: false,
      category_filter_label: "Select category",
      available_filters: {
        "": "Select Content Type",
        blog: "Blogs",
        datasheet: "Datasheets",
        insights: "Insights",
        news: "News",
        video: "Videos"
      },
      current_content_type: window.resources_current_content_type,
      current_category: window.resources_current_category,
      available_categories: window.resources_available_categories
    };
  },
  created() {
    // Set the content type filter title
    if (this.get_current_content_type && this.get_current_content_type !== "") {
      this.available_filters[""] = "All Content";
    }
  },
  mounted() {},
  methods: {
    applyTypeFilter(typeSlug) {
      let filterQuery = window.location.href.split("?")
        ? window.location.href.split("?")[1]
        : null;
      if (filterQuery) {
        window.location.href = "/resources/" + typeSlug + "?" + filterQuery;
      } else {
        window.location.href = "/resources/" + typeSlug;
      }
    },
    applyCategoryFilter(category) {
      let filterSlug = category.slug;
      if (!filterSlug || filterSlug === "") {
        window.location.href = "/resources/";
      } else {
        let locationWithoutQuery = window.location.href.split("?")[0];
        window.location.href = locationWithoutQuery + "?filter=" + filterSlug;
      }
    },
    typeFilterClass() {
      return this.type_filter_open
        ? "news-filter news-filter--open"
        : "news-filter";
    },
    categoryFilterClass() {
      return this.category_filter_open
        ? "news-filter news-filter--open"
        : "news-filter";
    },
    getTypeFilterLabel() {
      if (this.type_filter_open) {
        return this.type_filter_label;
      } else if (this.current_content_type !== "") {
        let activeFilterTitle = this.available_filters[
          this.current_content_type
        ];
        return activeFilterTitle;
      } else {
        return this.type_filter_label;
      }
    },
    getCategoryFilterLabel() {
      if (this.category_filter_open) {
        return this.category_filter_label;
      } else if (this.current_category !== "") {
        let activeFilter = this.available_categories.filter(item => {
          return item.slug === this.current_category;
        });
        if (activeFilter.length) {
          let activeFilterTitle = activeFilter[0].name;
          return activeFilterTitle;
        } else {
          return this.type_filter_label;
        }
      } else {
        return this.type_filter_label;
      }
    }
  },
  computed: {
    get_current_content_type() {
      if (this.current_content_type === "filter") {
        return "";
      } else {
        return this.current_content_type;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.news-filter {
  position: relative;
  min-width: 270px;

  &__inner {
    position: absolute;
    background-color: white;
    min-width: 270px;
    z-index: 10;

    .news-filter--open & {
      box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
    }

    dl {
      margin: 0;
      padding: 0;
      cursor: pointer;
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;

      dt {
        color: #3c505a;
        display: flex;
        justify-content: space-between;
        padding: 0 7px;

        .label {
          padding: 11px 0 12px;
          display: flex;
          flex: 1 1 auto;
          border-bottom: 1px solid #dcdcdc;
        }

        .arrow {
          flex: 0 0 43px;
          border-bottom: 1px solid #dcdcdc;
          display: flex;
          height: 44px;

          &:hover,
          &:focus {
            .news-filter--open & {
              border-bottom: 1px solid #dc281e;
            }
          }

          &:after {
            content: "";
            background: {
              image: url("/app/themes/redbeemedia/images/chevron-red-right.svg");
              size: 6px;
              repeat: no-repeat;
              position: center;
            }
            display: block;
            width: 100%;
            height: 100%;
            transform: rotate(270deg);
            transition: transform 0.3s ease-in-out;

            .news-filter--open & {
              transform: rotate(90deg);
            }
          }
        }
      }

      .dd-container {
        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;
      }

      dd {
        display: none;
        padding: 11px 7px 12px;
        margin-bottom: 0;
        align-items: center;
        justify-content: space-between;
        margin-inline-start: 0;

        .news-filter--open & {
          display: flex;
        }

        &.active,
        &:hover {
          background-color: #dc281e;
          color: white;
        }

        &.active {
          background: {
            image: url("/app/themes/redbeemedia/images/tick-white.svg");
            size: 12px;
            repeat: no-repeat;
            position: calc(100% - 24px);
          }
        }
      }
    }
  }
}
</style>
